<div class="no-data-wrapper">
  <img src="assets/images/no-data.png" alt="No data" class="no-data-illustration" />
  <p class="no-data-title">{{ customMessage ? customMessage : 'No Data to Display' }}</p>
  <p class="no-data-subtitle">No records found at this time.</p>
</div>